module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-Warwick-6ed174687aeff0c76170ab87fa02aa83.svg";